module.exports = __webpack_public_path__ + "static/media/fail.8e88f0d5.png";